'SettingsMaint'.maint({expose: true, panelStyle: "titled", icon: 'Cog'})
'Settings'.title()
'Back'.action({act: 'cancel'})
'OK'.action({act: 'ok'})
'Security'.action({spec: "ManageSecurity.js", icon: 'Lock'})
'Manage Account'.action({spec: "ManageAccount.js"})
'Currencies'.action({spec: "CurrencyList.js"})
'Units of Measure'.action({spec: "UOMList.js"})
'Utilities'.action({spec: "Utilities.js"})
'Modify Profitori'.action({spec: "Modify.js"})
'Configuration'.datatype()

'Regional Settings'.panel()
'shortDateFormat'.field()
'displayDatesUsingShortDateFormat'.field({yesOrNo: true})

'Reporting'.panel()
'salesProjectionPriorWeeks'.field()

'Performance'.panel()
'databaseOptimized'.field({readOnly: true})

'Attachments'.panel()
'storeAttachmentsInSecureLocation'.field()
'attachmentsPathOnServer'.field()

'Inventory'.panel()
'defaultStockingUOM'.field({refersTo: 'UOM', caption: 'Default Stocking Unit of Measure'})
'showUOMOnPOLines'.field({yesOrNo: true, caption: 'Show Unit of Measure on PO Lines'})
'suppressPOQuantityOnHandUpdates'.field({caption: 'Suppress PO Receipt updates to Quantity On Hand'})

''.panel()

'Purchasing'.panel()
'businessName'.field()
'poPdfLogoUrl'.field({caption: 'Purchase Order PDF Logo URL'})
'deliveryAddress'.field({caption: 'Address for Deliveries'})
'deliveryCity'.field({caption: 'City/Suburb/Town'})
'deliveryState'.field({caption: 'State/Province'})
'deliveryPostcode'.field({caption: 'Postal/Zip Code'})
'deliveryCountry'.field({caption: 'Country'})
'email'.field()
'phoneNumber'.field({caption: 'Phone'})
'taxPct'.field({numeric: true, decimals: 2, caption: "Default Tax %"}) 
'enterPurchasePricesInclusiveOfTax'.field({yesOrNo: true})
'sortPOPdfBySupplierSku'.field()

'Sales Invoicing'.panel()
'salesInvoiceBusinessName'.field({caption: "Business Name"})
'salesInvoiceAddress'.field({caption: 'Address for Sales Invoices'})
'salesInvoiceCity'.field({caption: 'City/Suburb/Town'})
'salesInvoiceState'.field({caption: 'State/Province'})
'salesInvoicePostcode'.field({caption: 'Postal/Zip Code'})
'salesInvoiceCountry'.field({caption: 'Country'})
'salesInvoiceEmail'.field({caption: 'Email'})
'salesInvoicePhoneNumber'.field({caption: 'Phone'})
'salesInvoiceTaxId'.field({caption: 'Tax ID'})
'salesInvoicePaymentInstructions'.field({caption: 'Payment Instructions'})
'salesInvoiceTerms'.field({caption: 'Terms'})
'salesInvoiceDaysToPay'.field({caption: 'Days to Pay', numeric: true})

'Stocktake'.panel()
'showDiscrepanciesInCountPage'.field({yesOrNo: true})

'Fulfillment'.panel()
'prioritizeOrderCompletion'.field({yesOrNo: true, caption: "Fulfill Fully Satisfiable Orders First"})

'attachmentsPathOnServer'.visibleWhen((maint, configuration) => {
  return configuration.storeAttachmentsInSecureLocation === 'Yes'
})
